import { createFileRoute, Link, redirect } from '@tanstack/react-router'
import { ArticleReader } from '../../components/public-kb/ArticleReader'
import { PublicKbError } from '../../components/public-kb/PublicKbError'
import { publicArticleQueryOptions } from '../../hooks/usePublicKb'
import { isPublicKbHost } from '../../lib/public-kb-host'

export const Route = createFileRoute('/knowledge/a/$articleSlug')({
  beforeLoad: async ({ context, params }) => {
    if (!isPublicKbHost()) {
      throw redirect({ to: '/' })
    }

    try {
      const article = await context.queryClient.ensureQueryData(
        publicArticleQueryOptions(params.articleSlug),
      )
      return { publicArticle: article, articleNotFound: false as const }
    } catch {
      return { publicArticle: null, articleNotFound: true as const }
    }
  },
  component: PublicArticlePage,
})

function PublicArticlePage() {
  const { publicWorkspace, publicArticle, articleNotFound } = Route.useRouteContext()

  if (!publicWorkspace) return null

  if (articleNotFound || !publicArticle) {
    return (
      <PublicKbError
        title="Article not found"
        message="This article does not exist or is no longer published."
        action={
          <Link
            to="/knowledge"
            className="mt-6 inline-flex text-sm font-medium text-foreground underline-offset-4 hover:underline"
          >
            Back to help center
          </Link>
        }
      />
    )
  }

  return <ArticleReader article={publicArticle} workspace={publicWorkspace} />
}
